export default [{
  path: '/sublimite',
  component: {
    name: 'sublimite',
    template: '<router-view />',
    meta: {
      resource: 'sublimite',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'sublimite-view',
    component: () => import('@/app/sublimite/SublimiteView.vue'),
    meta: {
      resource: 'sublimite',
      action: 'read',
      navActiveLink: 'sublimite-view',
      pageTitle: 'Sublimite SN',
      breadcrumb: [
        {
          text: 'Sublimite SN',
          to: { name: 'sublimite-view' },
          active: true,
        },
      ],
    },
  }],
},
]
